import React from "react";
import {Dictionary} from "./Dictionary";
import {XHR} from "./XHR";
import {LocalStorage} from "./LocalStorage";
import {User} from "./User";

export abstract class AdminComponent extends React.Component<any, any> {

    protected dictionary: Dictionary = new Dictionary();
    protected user: User = new User();
    protected request: XHR = new XHR();
    protected storage: LocalStorage = new LocalStorage();
    public static params: string[] = [];

    constructor(props: any) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    protected getParams(): string[] {
        return AdminComponent.params;
    }

    protected handleSubmit(event: any): any {

    }

    protected getRequestUrl(event = null): RequestInfo | URL {
        //@ts-ignore
        if (event && event.target && event.target.attributes !== undefined && event.target.attributes.action !== undefined) {
            //@ts-ignore
            return event.target.attributes.action.value;
        }
        return '/';
    }

    protected onError(error: any, event: SubmitEvent | null = null) {
        if (this.request.isUnauthorized()) {
            this.storage.clear();
            window.location.reload();
            return;
        }

        if (event && event.target instanceof HTMLFormElement && event.target.querySelector('.alert.alert-danger')) {
            (event.target.querySelector('.alert.alert-danger') as HTMLElement).innerHTML = error.message;
            (event.target.querySelector('.alert.alert-danger') as HTMLElement).classList.remove('hide');
            return;
        }

        if (document.querySelector('form .alert.alert-danger')) {
            (document.querySelector('form .alert.alert-danger') as HTMLElement).innerHTML = error.message;
            (document.querySelector('form .alert.alert-danger') as HTMLElement).classList.remove('hide');
            return;
        }

        console.error(error);
    }
}
